import {
  ActiveCostCenterResponse,
  CreateTeamRequest,
  TeamMembershipResponse,
  TeamResponse,
  UpdateTeamMemberRoleRequest,
  UpdateTeamRequest,
} from './generated'
import { fetchAPI } from '.'

/** Create a team scoped to the given cost center. */
export async function createTeam(costCenterId: string, data: CreateTeamRequest) {
  return fetchAPI<TeamResponse>({
    method: 'POST',
    url: `/api/v1/cost-centers/${encodeURIComponent(costCenterId)}/teams`,
    data,
  })
}

/** Fetch the caller's cost center plus all active members of every team in it.
 *  Powers the create-department dialog's CC-scoped member picker. 404 if the
 *  caller has no active team membership.
 */
export async function getActiveCostCenterForCaller() {
  return fetchAPI<ActiveCostCenterResponse>({
    method: 'GET',
    url: '/api/v1/me/active-cost-center',
  })
}

/** Rename a team. The caller must be an enterprise admin or team admin. */
export async function updateTeam(teamId: string, data: UpdateTeamRequest) {
  return fetchAPI<TeamResponse>({
    method: 'PATCH',
    url: `/api/v1/teams/${encodeURIComponent(teamId)}`,
    data,
  })
}

/**
 * Disband (soft-delete) a team. Returns 400 if called against the General team.
 * Members are soft-removed by the backend; the frontend should reassign members
 * to a destination team via {@link moveMemberToTeam} before calling this.
 */
export async function disbandTeam(teamId: string) {
  return fetchAPI<{ message?: string }>({
    method: 'DELETE',
    url: `/api/v1/teams/${encodeURIComponent(teamId)}`,
  })
}

/**
 * Set the per-team membership role (admin or member) for a user already on the team.
 * Backend refuses to demote the last effective admin while the team has other members.
 */
export async function updateTeamMemberRole(teamId: string, userId: string, data: UpdateTeamMemberRoleRequest) {
  return fetchAPI<TeamMembershipResponse>({
    method: 'PATCH',
    url: `/api/v1/teams/${encodeURIComponent(teamId)}/members/${encodeURIComponent(userId)}`,
    data,
  })
}
